import { appConfig } from 'config/customization';

export default {
  containerHidden: {
    height: 0
  },
  containerShow: {
    marginTop: '1.5rem',
    position: 'absolute',
    top: 30,
    right: 10,
    background: appConfig.colors.white,
    width: 320,
    borderRadius: 5,
    boxShadow: `0 8px 13px 0 ${appConfig.colors.translucentGray}`,
    height: 425,
    overflowY: 'auto',
    overflowX: 'hidden',
    transition: 'height 0.7s ease',
    zIndex: 6
  },
  spinnerContainer: {
    position: 'sticky',
    bottom: 0,
    padding: 5,
    backgroundColor: appConfig.colors.lightGray,
    width: '100%',
    textAlign: 'center'
  }
};
